import React from 'react';
import { BpmTable } from './BpmTable';
import { getMonthName } from './utils';

export const MonthlySectionDataTable = ({ rawData, dataMember }) => {
    if (!rawData) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(rawData, dataMember);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(rawData, dataMember) {
    const result = {
        rows: [], cols: [
            {
                title: 'Family Number', field: 'sectionNumber'
            },
            {
                title: 'Family Name', field: 'sectionTitle'
            }]
    };
    const rowsBySectionNumber = new Map();
    const dates = new Set();

    // Create a column for each month-year combination, and populate each row.
    for (const data of rawData) {
        const sectionNumber = data.sectionNumber;
        let row;
        if (rowsBySectionNumber.has(sectionNumber)) {
            row = rowsBySectionNumber.get(sectionNumber);
        } else {
            row = { sectionTitle: data.sectionTitle, sectionNumber: data.sectionNumber };
            rowsBySectionNumber.set(sectionNumber, row);
            result.rows.push(row);
        }

        const month = getMonthName(data.month);
        const dateColName = `${month}-${data.year}`;
        row[dateColName] = data[dataMember];
        const monthAndYear = `${data.month.toString().padStart(2, '0')}-${data.year}`
        if (!dates.has(monthAndYear)) {
            dates.add(monthAndYear);
        }
    }

    // Add date columns by month and then year
    const dateCols = Array.from(dates)
        .sort()
        .map(d => {
            const elements = d.split('-');
            const month = getMonthName(parseInt(elements[0]));
            const year = elements[1];
            const colName = `${month}-${year}`;
            return {
                title: colName,
                field: colName
            };
        });

    result.cols.push(...dateCols);
    return result;
}
